import { RequestIdentity } from './RequestIdentity';
import { requestIdentityToString } from '../utils/requestIdentityToString';

export type ViewParams = RequestIdentity & { moduleKey: string };

export const viewParamsToString = (params: ViewParams): string => {
  return `${params.moduleKey}/${requestIdentityToString(params)}`;
};